<template lang="pug">
.md-layout
  .md-layout-item
    md-card#data-table
      md-card-header#header.md-card-header-icon.md-card-header-green
        .card-icon
          md-icon(v-if='customIcon === null') {{tableIcon}}
          TableChartView(v-else-if='customIcon === "lista-campanhas"')
          AccountCircle(v-else-if='customIcon === "user-config-circle"')
          ManageAccount(v-else-if='customIcon === "manage-account"')
          v-icon(v-else size="25px") {{customIcon}}
        h4.title.inlineTitle
          | {{ title }}
        md-button.margin-left.margin-top(@click='generateFile("print")' v-if='!excludeHeader && buttonHeaders && enablePDF'
          :disabled='loadingGeneration.print || dialogsGeneration' class='md-sm md-facebook' style='float: right;')
          template(v-if='!loadingGeneration.print')
            md-icon(style='font-size: 24px !important;') print
            md-tooltip(md-direction="bottom")
              | {{$t('dataTable.printOut')}}
          template(v-else)
            v-progress-circular(
              size='24',
              width='2',
              style='transition: 0.1s; height: 33px;'
              color='#fff'
              indeterminate)
        VueJsonToCsv(:id="csvComponentId" :json-data='csvData' :csv-title="csvName" :labels='formatedCVSLabels' style='opacity: 0; pointer-events: none;')
        md-button.margin-left.margin-top(@click='generateFile("csv")' v-if='!excludeHeader && buttonHeaders'
          :disabled='loadingGeneration.csv || dialogsGeneration' class='md-sm md-facebook' style='float: right;')
          template(v-if='!loadingGeneration.csv')
            md-icon(style='font-size: 24px !important;') table_view
            md-tooltip(md-direction="bottom")
              | {{$t('dataTable.generateSpreadsheet')}}
          template(v-else)
            v-progress-circular(
              size='24',
              width='2',
              style='transition: 0.1s; height: 33px;'
              color='#fff'
              indeterminate)
        md-button.margin-top(@click='generateFile("pdf")' v-if='!excludeHeader && buttonHeaders && enablePDF'
          :disabled='loadingGeneration.pdf || dialogsGeneration' class='md-sm md-facebook' style='float: right; margin-right: 0px;')
          template(v-if='!loadingGeneration.pdf')
            md-icon(style='font-size: 24px !important;') picture_as_pdf
            md-tooltip(md-direction="bottom")
              | {{$t('dataTable.exportPdf')}}
          template(v-else)
            v-progress-circular(
              size='24',
              width='2',
              style='transition: 0.1s; height: 33px;'
              color='#fff'
              indeterminate)
        md-button.margin-top(@click='generateFile("xlsx")' v-if='!excludeHeader && buttonHeaders && isSefMg'
          :disabled='loadingGeneration.xlsx || dialogsGeneration' class='md-sm md-facebook'
          style='float: right; margin-right: 0px;')
          template(v-if='!loadingGeneration.xlsx')
            XLSXIcon.icon-size
            md-tooltip(md-direction="bottom")
              | {{$t('dataTable.exportXLSX')}}
          template(v-else)
            v-progress-circular(
              size='24',
              width='2',
              style='transition: 0.1s; height: 33px;'
              color='#fff'
              indeterminate)
        md-button.margin-top(@click='generateFile("xls")' v-if='!excludeHeader && buttonHeaders && isSefMg'
          :disabled='loadingGeneration.xls || dialogsGeneration' class='md-sm md-facebook'
          style='float: right; margin-right: 0px;')
          template(v-if='!loadingGeneration.xls')
            XLSIcon.icon-size
            md-tooltip(md-direction="bottom")
              | {{$t('dataTable.exportXLS')}}
          template(v-else)
            v-progress-circular(
              size='24',
              width='2',
              style='transition: 0.1s; height: 33px;'
              color='#fff'
              indeterminate)
        slot(name='custom-filter')
        slot(name='title-left')
      md-card-content
        md-progress-bar.md-primary(
          v-if="loading"
          md-mode='query'
          style='margin-bottom: 0px;')
        md-table.paginated-table.table-striped.table-hover(
          id='chatList'
          v-model='data',
          :md-sort='currentSort',
          @update:mdSort='$emit("update:currentSort", $event)'
          :md-sort-order='currentSortOrder',
          @update:mdSortOrder='$emit("update:currentSortOrder", $event)'
          :md-sort-fn='customSort',
          :md-selected-value.sync='selected'
          @update:mdSelectedValue='$emit("selected-items", $event)')
          md-table-toolbar(v-if='!customHeader && !excludeHeader')
            md-field(:class="excludeTopPagination ? 'invisible' : ''")
              label(for='pages') {{ $t("commonPhrases.perPage") }}
              md-select(v-model='pagination.perPage' name='pages')
                md-option(
                  v-for='item in pagination.perPageOptions',
                  :key='item',
                  :label='item',
                  :value='item') {{ item }}
            md-field
              md-input.mb-3(
                type='search'
                clearable
                style='width: 200px;',
                :placeholder='customSearchLabel ? $t(customSearchLabel) : $t("commonWords.search") + "..."',
                :value='searchQuery'
                @input='updateSearch')
          template(v-else='!excludeHeader')
            slot(name='custom-header' :pagination='pagination')
          md-table-toolbar(
            v-if='selectable'
            slot='md-table-alternate-header'
            slot-scope='{ count }'
            style='position: relative;')
            .backgroundRed.md-toolbar
              .md-toolbar-section-start
                | {{ count }}
                | {{ count > 1 ? $t("commonWords.itemsSelected") : $t("commonWords.itemSelected") }}
              .md-toolbar-section-end(v-if='selectable')
                div(v-if='!allowDeleteSelected')
                  slot(name='deleteSelectedMessage')
                md-button.md-simple.md-github(
                  :disabled='isReadOnly || !allowDeleteSelected'
                  @click='$emit("delete-selected", selected)')
                  md-icon delete
                  | {{ $t("commonWords.delete") }}
                md-button.md-simple.md-github(@click='clearSelection') {{ $t("commonWords.cancel") }}
          slot(name='no-data')
          md-table-row(
            slot='md-table-row'
            slot-scope='props'
            :md-selectable='selectable ? "multiple" : undefined'
            @click='$emit("click-row", props)'
            style='cursor: pointer;',
            :class='rowClasses(props.item)')
            slot(name='cells' v-bind='props')
      md-card-actions(md-alignment='space-between' v-if='!excludeHeader && showPagination')
        div
          p.card-category
            | {{ $t("commonWords.showingItems", { from: from + 1, to: to, total: total }) }}
        slot(name='footer' :pagination='pagination')
        pagination.pagination-no-border.pagination-success(
          :limitPagination='limitPagination'
          v-model='pagination.currentPage'
          @input='$emit("update:currentPage", pagination.currentPage)',
          @next='$emit("nextPage", pagination.currentPage)'
          @prev='$emit("prevPage", pagination.currentPage)'
          :per-page='pagination.perPage'
          :total='total')
  //- esse dialog só é mostrado se tiver um carregamento demorado
  //- (geralmente mais de 1000 itens)
  v-dialog(v-model='dialogsGeneration' persistent max-width="400")
    v-card(style='padding: 8px;')
      v-card-text(style='text-align: center; padding-top: 4px;')
        h3 {{ slowRequestMessage() }}
        v-progress-circular(
          size='200',
          width='4',
          style='transition: 0.1s'
          color='#9c27b0'
          :value='progress',
          :indeterminate='progress >= 90')
          b(v-if='progress !== null' style='font-size: 35px;') {{ progress + "%" }}
      v-card-actions.mt-2.pb-3.px-4
        v-btn.elevation-0(
          :disabled='progress >= 90'
          @click='dialogsGeneration = false',
          text,
          color='#FF0000') {{$t('dataTable.cancel')}}
        v-spacer
</template>

<script>
import Pagination from '@/components/Pagination.vue'
import enumPropValidator from '@/helpers/enumPropValidator'
import debounce from 'lodash.debounce'
import Swal from 'sweetalert2'
import jsPDF from 'jspdf'
import 'jspdf-autotable'
import * as XLSX from 'xlsx'
import VueJsonToCsv from 'vue-json-to-csv'
import TableChartView from '@/assets/img/table_chart_view.svg'
import AccountCircle from '@/assets/img/account_circle.svg'
import ManageAccount from '@/assets/img/manage_accounts.svg'
import isTenantMixin from '@/components/mixins/isTenantMixin'
import XLSXIcon from '@/assets/img/xlsx-icon.svg'
import XLSIcon from '@/assets/img/xls-icon.svg'

export default {
  name: 'DataTable',
  model: {
    prop: 'data'
  },
  props: {
    showPagination: { type: Boolean, default: true },
    limitPagination: { type: Boolean, default: false },
    data: { type: Array, default: Array },
    title: { required: true, type: String },
    isReadOnly: { default: false, type: Boolean },
    selectable: { type: Boolean, default: true },
    currentSort: { type: String },
    fileName: { type: String, default: 'omni_report' },
    tableIcon: { type: String, default: 'list_alt' },
    orientationPDF: { type: String, default: 'portrait' },
    currentSortOrder: {
      type: String,
      default: 'asc',
      ...enumPropValidator('md-sort-order', ['asc', 'desc'])
    },
    customSort: { required: false, type: Function },
    customTotal: { required: true, type: Number },
    customHeader: { type: Boolean, default: false },
    excludeHeader: { type: Boolean, default: false },
    enablePDF: { type: Boolean, default: true },
    loading: { type: Boolean, default: false },
    rowClasses: { type: Function, default: () => ({}) },
    allowDeleteSelected: { type: Boolean, default: true },
    endpoint: { required: true },
    filter: { required: true },
    labels: { required: true },
    formatLabelFunction: { type: Function },
    createHeader: { type: Function },
    csvComponentId: { type: String, default: 'csv-component' },
    customIcon: { type: String, default: null },
    customTableStyle: { type: Object, default: null },
    buttonHeaders: { type: Boolean, default: true },
    perPage: { type: Number, default: 5 },
    customSearchLabel: {
      type: String,
      default: ''
    },
    searchStyle: {
      type: String,
      default: () => 'width: 200px;'
    },
    excludeTopPagination: {
      type: Boolean,
      default: () => false
    }
  },
  components: {
    Pagination,
    VueJsonToCsv,
    TableChartView,
    AccountCircle,
    ManageAccount,
    XLSXIcon,
    XLSIcon
  },
  watch: {
    pagination: {
      handler: 'updatePagination',
      deep: true
    },
    loading (value) {
      if (value === false) {
        const vm = this
        setTimeout(() => {
          vm.delayedLoading = value
        }, 500)
      } else {
        this.delayedLoading = value
      }
    }
  },
  mixins: [isTenantMixin],
  computed: {
    to () {
      let highBound = this.from + this.pagination.perPage
      if (this.total < highBound) {
        highBound = this.total
      }
      return highBound
    },
    from () {
      return this.pagination.perPage * (this.pagination.currentPage - 1)
    },
    total () {
      return this.customTotal ?? (this.data?.length || 0)
    },
    progress () {
      return this.toFixed(this.progressGeneration, 1) * 100
    },
    formatedCVSLabels () {
      let csvObjLabels = {}
      // ['Início', 'Duração', 'Fim']
      // { inicio: {title: 'Início'}, ...}
      this.labels.forEach((label) => {
        csvObjLabels[this.strToSlug(label)] = {
          title: label
        }
      })
      return csvObjLabels
    }
  },
  data () {
    return {
      pagination: {
        perPage: this.perPage,
        currentPage: 1,
        perPageOptions: [5, 10, 25, 50]
      },
      searchQuery: '',
      selected: [],
      delayedLoading: false,
      dialogsGeneration: false,
      loadingGeneration: {
        pdf: false,
        xlsx: false,
        xls: false,
        csv: false,
        print: false
      },
      fileType: 'pdf',
      progressGeneration: 0,
      csvData: [],
      csvName: null
    }
  },
  methods: {
    updateSearch: debounce(function (value) {
      this.searchQuery = value
      this.$emit('search-query', value)
    }, 400),
    updatePagination (pagination, oldPagination) {
      this.$emit('pagination', pagination, oldPagination)
    },
    clearSelection () {
      this.selected = []
      this.$emit('clear-selection')
    },
    resetPagination () {
      this.pagination = {
        perPage: this.perPage,
        currentPage: 1,
        perPageOptions: [5, 10, 25, 50]
      }
    },
    slowRequestMessage () {
      if (this.fileType === 'pdf') {
        return this.$t('dataTable.generatingPdf')
      } else if (this.fileType === 'xlsx') {
        return this.$t('dataTable.generatingXLSX')
      } else if (this.fileType === 'xls') {
        return this.$t('dataTable.generatingXLS')
      } else if (this.fileType === 'csv') {
        return this.$t('dataTable.generatingCSV')
      }
    },
    async generateFile (type) {
      this.fileType = type
      const totalItems = JSON.parse(JSON.stringify(this.customTotal))
      this.progressGeneration = 0
      if (totalItems > 1000) {
        this.dialogsGeneration = true
      }
      this.loadingGeneration[type] = true
      let filterClone = JSON.parse(JSON.stringify(this.filter))
      const perPage = 10
      let event = type === 'pdf' || type === 'csv' ? 'download' : type
      filterClone.event = event

      if (filterClone.perPage) {
        filterClone.perPage = perPage
      }
      let dataPages
      try {
        const response = await this.$axios.get(this.endpoint, {
          params: filterClone
        })
        dataPages = [...response.data.data]
        const totalPages = response.data.total / perPage
        this.progressGeneration = 0.1
        const unity = 0.9 / parseInt(totalPages)
        for (let i = 1; i < totalPages; i++) {
          if (!this.dialogsGeneration && totalItems > 1000) throw new Error(this.$t('dataTable.canceledByUser'))
          filterClone.page = i
          let subsequentResponse = await this.$axios.get(this.endpoint, {
            params: filterClone
          })
          dataPages = [...dataPages, ...subsequentResponse.data.data]
          this.progressGeneration += unity
        }

        if (type === 'pdf' || type === 'print') {
          let bodyLabels = []
          let labelLine = []
          dataPages.forEach(item => {
            if (!this.dialogsGeneration && totalItems > 1000) throw new Error(this.$t('dataTable.canceledByUser'))
            this.labels.forEach((element, index) => {
              labelLine.push(this.formatLabelFunction(item, index))
            })
            bodyLabels.push(labelLine)
            labelLine = []
          })
          // eslint-disable-next-line
          const doc = new jsPDF({orientation: this.orientationPDF})

          let offSetY = this.createHeader(doc, this.customTotal)

          if (!this.dialogsGeneration && totalItems > 1000) throw new Error(this.$t('dataTable.canceledByUser'))
          doc.autoTable({
            headStyles: this.customTableStyle ? this.customTableStyle.headStyles : {
              overflow: 'linebreak',
              cellWidth: 'wrap'
            },
            bodyStyles: this.customTableStyle ? this.customTableStyle.bodyStyles : {
              overflow: 'linebreak',
              cellWidth: 'auto'
            },
            startY: offSetY,
            head: [this.labels],
            body: bodyLabels,
            styles: {
              cellPadding: 0,
              fontSize: 5,
              minCellWidth: 5
            }
          })
          // checamos se queremos só o pdf ou também queremos imprimir
          if (type === 'pdf') {
            let timestamp = Date.now()
            const fileNameDownload = `${timestamp}_${this.fileName}.pdf`
            doc.save(fileNameDownload)
          } else if (type === 'print') {
            window.open(doc.output('bloburl'))
          }
        } else if (type === 'csv') {
          let bodyLabels = []
          let lineObject = {}
          dataPages.forEach(item => {
            if (!this.dialogsGeneration && totalItems > 1000) throw new Error(this.$t('dataTable.canceledByUser'))
            this.labels.forEach((element, index) => {
              lineObject[this.strToSlug(element)] = this.formatLabelFunction(item, index)
            })
            bodyLabels.push(lineObject)
            lineObject = {}
          })
          this.csvData = bodyLabels
          let timestamp = Date.now()
          this.csvName = `${timestamp}_${this.fileName}`
          this.$nextTick(() => {
            document.querySelector(`#${this.csvComponentId}`).click()
          })
        } else if (type === 'xlsx' || type === 'xls') {
          let bodyLabels = []
          let labelLine = []
          dataPages.forEach(item => {
            if (!this.dialogsGeneration && totalItems > 1000) throw new Error(this.$t('dataTable.canceledByUser'))
            this.labels.forEach((element, index) => {
              labelLine.push(this.formatLabelFunction(item, index))
            })
            bodyLabels.push(labelLine)
            labelLine = []
          })
          const aoa = [this.labels, ...bodyLabels]
          const ws = XLSX.utils.aoa_to_sheet(aoa)
          const wb = XLSX.utils.book_new()
          XLSX.utils.book_append_sheet(wb, ws, 'Sheet1')
          if (type === 'xlsx') {
            XLSX.writeFile(wb, `${Date.now()}_${this.fileName}.xlsx`)
          } else if (type === 'xls') {
            XLSX.writeFile(wb, `${Date.now()}_${this.fileName}.xls`, { bookType: 'biff8' })
          }
        }
      } catch (error) {
        if (error.message === 'Cancelado pelo usuário.') {
          Swal.fire({
            icon: 'error',
            title: this.$t('dataTable.calledOff')
          })
        } else {
          if (type === 'csv') {
            Swal.fire({
              icon: 'error',
              title: this.$t('localDataTable.errorGeneratingCsv')
            })
          }
          if (type === 'xlsx') {
            Swal.fire({
              icon: 'error',
              title: this.$t('dataTable.errorGeneratingXLSX')
            })
          } else if (type === 'xls') {
            Swal.fire({
              icon: 'error',
              title: this.$t('dataTable.errorGeneratingXLS')
            })
          } else {
            Swal.fire({
              icon: 'error',
              title: this.$t('dataTable.errorGeneratingPdf')
            })
          }
        }
      } finally {
        this.dialogsGeneration = false
        this.loadingGeneration[type] = false
        setTimeout(() => {
          this.progressGeneration = 0
        }, 100)
      }
    },
    toFixed (value, precision) {
      var power = Math.pow(10, precision || 0)
      return Math.round(value * power) / power
    },
    strToSlug (str) {
      str = str.replace(/^\s+|\s+$/g, '') // trim
      str = str.toLowerCase()

      // remove accents, swap ñ for n, etc
      var from = 'ãàáäâẽèéëêìíïîõòóöôùúüûñç·/_,:;'
      var to = 'aaaaaeeeeeiiiiooooouuuunc------'
      for (var i = 0, l = from.length; i < l; i++) {
        str = str.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i))
      }

      str = str.replace(/[^a-z0-9 -]/g, '') // remove invalid chars
        .replace(/\s+/g, '-') // collapse whitespace and replace by -
        .replace(/-+/g, '-') // collapse dashes

      return str
    }
  },
  // created () {
  //   // this.resetPagination()
  //   // console.log(this.data)
  // },
  mounted () {
    this.$nextTick(() => {
      const headers = this.$el.querySelectorAll('th .md-table-head-container .md-table-head-label')

      headers.forEach(el => {
        let title = el.textContent
        el.setAttribute('title', title)
      })
    })
  }
}
</script>

<style lang="scss">
.invisible {
  visibility: hidden !important;
}
.md-card .md-card-actions {
  border: 0;
  margin-left: 20px;
  margin-right: 20px;
}
.md-checkbox.md-checked .md-checkbox-container:after {
  border-color: #33b231 !important;
  top: 1px !important;
  left: 6px !important;
}
.md-table-cell-container {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.md-table-alternate-header {
  top: 20px !important;
}
#chatList > .md-content > table > tbody > .md-table-row > .md-table-cell > .md-table-cell-container {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  text-align: left;
  display: block;
  -webkit-box-pack: none;
  -ms-flex-pack: none;
  justify-content: none;
}
#chatList > .md-content > table > thead > tr > .md-table-head > .md-table-head-container > .md-table-head-label {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
  text-align: left;
  &:hover {
    overflow: visible;
    white-space: normal;
  }
}
#chatList > .md-content > table > thead > tr > .md-table-head:last-child > .md-table-head-container > .md-table-head-label {
  padding-right: 0px !important;
  /* text-align: right; */
}
#chatList > .md-content > table > tbody > .md-table-row > .md-table-cell:hover > .md-table-cell-container {
  text-overflow: clip;
  white-space: normal;
  word-break: break-all;
}

.md-tooltip {
  height: 22px !important;
  padding: 8px !important;
  position: absolute !important;
  z-index: 9999 !important;
  pointer-events: none !important;
  border-radius: 2px !important;
  border-top-left-radius: 2px !important;
  border-top-right-radius: 2px !important;
  border-bottom-right-radius: 2px !important;
  border-bottom-left-radius: 2px !important;
  transition: 0.15s cubic-bezier(0, 0, 0.2, 1) !important;
  transition-property: opacity, transform !important;
  will-change: opacity, transform, top, left !important;
  font-size: 10px !important;
  line-height: 22px !important;
  text-transform: none !important;
  white-space: nowrap !important;
  min-width: none !important;
  width: 170px !important;
  max-width: 1000px !important;
  height: auto !important;
  line-height: 20px !important;
  text-align: center !important;
  border-radius: 3px !important;
  background-color: rgba(97, 97, 97, 0.9) !important;
  color: white !important;
  font-size: 14px !important;
  font-weight: 400 !important;
  white-space: normal !important;
  box-shadow: none !important;
}

.md-tooltip:after {
  opacity: 0;
}

#data-table #header .margin-top {
  margin-top: 15px;
}

#data-table #header .margin-left {
  margin-left: 8px;
}

.icon-size{
  width: 24px;
  height: 24px;
  margin:  4.5px 0;
}

.icon-size svg {
  font-size: 24px;
}
</style>
